/* eslint no-template-curly-in-string: 0 */
import bassProLogo from "../../assets/images/bass-pro-shops-logo.jpg";
import bassProGiftCard from "../../assets/images/bass-pro-shops-logo.jpg";
import { FLOW_TYPES, PAYMENT_NETWORKS, PAYMENT_STATUSES } from "../../utils/enums";

const css = {
  // ":root": {
  //   "--btn-primary-bg-color": "red",
  //   "--btn-primary-bg-color-hover": "red",
  //   "--btn-primary-font-color": "#fff",
  //   "--btn-primary-font-color-hover": "#fff"
  // },
};

const aboutNetworkFaq = {
  answer: "Your Adventure Starts Here®.  Select from a wide variety of outdoor merchandise from Bass Pro Shops®.  We carry top quality gear for fishing, hunting and the outdoors! Including camping, boating, saltwater fishing, rugged footwear, casual clothing, and even outdoor decor and gifts!<br><br><strong>**PROTECT THIS CARD LIKE CASH**</strong> For customer service or balance inquiries, visit <a href=\"www.basspro.com/balance\">www.basspro.com/balance</a>, see any cashier, or call <a href=\"tel:+1-800-494-1100\">1-800-494-1100</a>. This Gift Card is redeemable for merchandise, food and beverages only at Bass Pro Shops stores, restaurants, or catalogs; online at <a href=\"http://www.basspro.com\">basspro.com</a> or <a href=\"http://www.big-cedar.com\">big-cedar.com</a>; or at Bass Pro resorts (Big Cypress, Big Cedar, Top of the Rock or Buffalo Ridge). Except as required by law, this card is not redeemable or exchangeable for cash, check, or credit. This Card is not a credit or debit card and is not reloadable. This Card does not expire and is valid until redeemed. The Card issuer is BPIP, LLC. All rights reserved. Purchase or use of this card constitutes acceptance of the Bass Pro Shops Gift Card Terms & Conditions, found at <a href=\"http://www.basspro.com/giftcardterms\">www.basspro.com/giftcardterms</a>, including binding arbitration and your waiver of rights to participate in a class action against Bass Pro Shops®.",
  question: "About Bass Pro Shops® eGiftcard"
}

export const bassProShops = {
  id: PAYMENT_NETWORKS.BASS_PRO_SHOPS,
  displayName: "Bass Pro Shops",
  paymentFlow: "email",
  paywall: {
    tile: {
      displayName: "Bass Pro Shops eGiftCard™",
      tagline: "Use online or in-store",
      description: [
        {
          string: "Immediate funds to buy your favorite",
          type: "div",
        },
        {
          string: "items, gifts, and more",
          type: "div",
        },
      ],
      // btnLabel: "Next",
      logo: bassProLogo
    }
  },
  recipientLogin: {
    flow: FLOW_TYPES.RECIPIENT_LOGIN.AUTO_LOGIN,
    loading: {
      title: "Preparing your Bass Pro Shops eGiftCard™"
    }
  },
  acceptPayment: {
    css,
    flow: FLOW_TYPES.ACCEPT_PAYMENT.AUTO_ACCEPT,
    description: [
      "You have chosen to receive a ",
      {
        string: "${payment.amount}",
        transformations: [
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.currency}"
            }
          }
        ],
        props: {
          className: "payment-amount",
        }
      },
      " Bass Pro Shops eGift which will be emailed to ",
      {
        string: "${payment.recipientEmail}.",
        props: {
          className: 'payment-recipientEmail',
        }
      }
    ],
    imgSrc: bassProGiftCard
  },
  paymentComplete: {
    initial: {
      description: [
        "Success! Please check your email ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail',
          },
        },
        " for details regarding your ",
        {
          string: "Bass Pro Shops eGiftCard™",
          props: {
            className: 'payment-paymentNetwork',
          }
        },
        " for ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        ". It should arrive soon and will include details for your use.",
      ],
      secondaryText: "Please treat this card like cash and care for it accordingly to avoid loss or theft.",
    },
    revisit: {
      description: [
        "An email was sent to ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail'
          },
        },
        " on ",
        {
          string: "${payment.updatedAt}",
          props: {
            className: 'payment-updatedAt'
          },
          transformations: [
            {
              type: "formatDate"
            }
          ],
        },
        " with details regarding your ",
        {
          string: "Bass Pro Shops eGiftCard™",
          props: {
            className: 'payment-paymentNetwork'
          }
        },
        " for ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
      ],
      secondaryText: "Please treat this card like cash and care for it accordingly to avoid loss or theft.",
    },
    imgSrc: bassProGiftCard,
  },
  faqs: {
    byPaymentStatus: {
      [PAYMENT_STATUSES.PENDING_ACCEPTANCE]: [
        aboutNetworkFaq,
      ],
      [PAYMENT_STATUSES.ACCEPTED]: [
        aboutNetworkFaq
      ],
      [PAYMENT_STATUSES.COMPLETE]: [
        aboutNetworkFaq
      ]
    }
  },
  onHold: {
    imgSrc: bassProLogo,
    description: 'Your payment selection has been received. In most cases, funds are instantly sent; however in some instances it can take 24 to 48 hours for money to arrive.',
  }
};

export default bassProShops;
